import { render, staticRenderFns } from "./DobInput.vue?vue&type=template&id=b6e88656&scoped=true&"
import script from "./DobInput.vue?vue&type=script&lang=js&"
export * from "./DobInput.vue?vue&type=script&lang=js&"
import style0 from "./DobInput.vue?vue&type=style&index=0&id=b6e88656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e88656",
  null
  
)

export default component.exports